/**
 * Функция форматирования ФИО
 * @param surName - Фамилия
 * @param name - Имя
 * @param patronymic - Отчество
 * @param format -  Формат, к которому необходимо привести ФИО, \
 * Аргументы: `S` - инициал фамилии(SurName), `N` - инициал имени(Name), `P` - инициал отчества(Patronymic) \
 * Приписка `f` в конце аргумента означает full, т.е. вывести не инициал, а полностью \
 * __По умолчанию: `Sf N. P.`__ \
 * Примеры {@linkcode format}:
 * - `S.N.P` - вернёт инициалы в заданном порядке с нужным разделителем С.Р.Г
 * - `Sf N P` - вернёт Соскин Р Г
 * - `Nf Pf = S` - вернёт Роман Геннадьевич = С
 * @returns ФИО в соответствии с переданным форматом
 */
export const formatFullName = (surName: string, name: string, patronymic: string, format: string = "Sf N. P."): string => {
    let result = format;
    // Замена аргументов формата на инициалы или полные имена
    /**
     * @TODO  реплейсы идут поочерёдно, и может быть так,
     * что то что вставляется будет содержать Аргумент, например S, который повторно реплейснится
     */
    result = result.replace(/Sf/g, surName);
    result = result.replace(/Nf/g, name);
    result = result.replace(/Pf/g, patronymic);
    result = result.replace(/S/g, surName.charAt(0));
    result = result.replace(/N/g, name.charAt(0));
    result = result.replace(/P/g, patronymic.charAt(0));

    return result;
};
